import type { Command } from "../../types";
import type { ShapeManager } from "../ShapeManager";
import type { IShape } from "../shapes/interfaces/IShape";

export class AddShape implements Command {
    private shapeManager: ShapeManager;
    private shape: IShape;

    constructor(shapeManager: ShapeManager, shape: IShape) {
        this.shapeManager = shapeManager;
        this.shape = shape;
    }

    execute(): void {
        this.shapeManager._addShape(this.shape);
    }

    undo(): void {
        this.shapeManager._removeShape(this.shape);
    }
}